<div class="reset-password-container">
  <div class="reset-password-card">
    <!-- Invalid link -->
    @if (hasPasswordResetingFailed) {
    <div>
      <p class="text-center pb-5">Линкът за смяна на парола е невалиден</p>
      <p class="text-center pb-5">
        Линкът, който сте използвали е изтекъл или вече е бил използван
      </p>
      <p class="text-center pb-5">
        Моля, подайте нова заявка за смяна на паролата, за да получите актуален
        линк
      </p>

      <p-button [rounded]="true" (onClick)="onResendPasswordLink()" label="Заявка да смяна на парола" severity="primary"
        type="submit" styleClass="!w-full h-full" [loading]="loading" />
    </div>
    } @else {
    <!-- Reset password form -->
    <div class="pb-5">
      <h1 class="pb-5 text-xl">Въведете новата си парола.</h1>
      <p>Потвърдете като я повторите</p>
    </div>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <otw-form-field label="Парола" for="password" labelClassNames="!text-black" classNames="!w-full">
        <p-password formControlName="password" inputId="password" inputStyleClass="w-full" styleClass="w-full"
          name="password" required [toggleMask]="true" [feedback]="true" size="small" class="w-full">
          <ng-template #header>
            <div class="font-semibold text-xm mb-4">Въведете парола</div>
          </ng-template>
          <ng-template #footer>
            <p-divider />
            <ul class="list-disc pl-2 ml-2 my-0 leading-normal">
              <li>Поне една главна буква</li>
              <li>Поне един специален символ</li>
              <li>Поне една цифра</li>
              <li>Поне 8 символа</li>
            </ul>
          </ng-template>
        </p-password>
      </otw-form-field>

      <otw-form-field label="Повтори паролата" for="password_confirmation" labelClassNames="!text-black"
        classNames="!w-full">
        <p-password formControlName="password_confirmation" inputId="password_confirmation" inputStyleClass="w-full"
          styleClass="w-full" name="password_confirmation" required [toggleMask]="true" [feedback]="true" size="small"
          class="w-full">
          <ng-template #header>
            <div class="font-semibold text-xm mb-4">Пoвторете паролата</div>
          </ng-template>
          <ng-template #footer>
            <p-divider />
            <ul class="list-disc pl-2 ml-2 my-0 leading-normal">
              <li>Поне една главна буква</li>
              <li>Поне един специален символ</li>
              <li>Поне една цифра</li>
              <li>Поне 8 символа</li>
            </ul>
          </ng-template></p-password>
      </otw-form-field>

      <div *ngIf="generalError" class="col-span-full text-center text-red-500">
        {{ generalError }}
      </div>

      <p-button [rounded]="true" label="Запазете" severity="primary" type="submit" styleClass="!w-full h-full"
        [loading]="loading" />
    </form>
    }
  </div>
</div>
<p-dialog header="Потвърдете смяната на парола" [(visible)]="confirmVisible" [modal]="true" [dismissableMask]="true">
  <p>Сигурни ли сте, че искате да смените паролата си?</p>
  <div class="flex justify-end gap-2 mt-4">
    <p-button label="Откажи" (onClick)="confirmVisible = false" severity="secondary"></p-button>
    <p-button label="Потвърди" (onClick)="onConfirmReset()" [loading]="loading" severity="primary"></p-button>
  </div>
</p-dialog>

<p-dialog [(visible)]="resultVisible" [modal]="true" [dismissableMask]="true" [style]="{ width: '400px' }">
  <ng-template pTemplate="header">
    <span [ngClass]="
      modalSeverity === 'danger' ? 'text-red-600' : 'text-primary-500'
    ">
      {{ modalMessage }}
    </span>
  </ng-template>
  <div class="flex justify-center mt-4">
    <p-button label="Затвори" (onClick)="onCloseResult()" severity="secondary"></p-button>
  </div>
</p-dialog>